'use client';

import React, { useState } from 'react';

import Icon from '@/components/ui/AppIcon';

const sidebarLinks = [
  { id: 'dash-overview', label: 'Overview', icon: 'HomeIcon', href: '/user-dashboard', badge: null },
  { id: 'dash-watchlist', label: 'Watchlist', icon: 'BookmarkIcon', href: '/user-dashboard', badge: '14' },
  { id: 'dash-watched', label: 'Watched', icon: 'EyeIcon', href: '/user-dashboard', badge: null },
  { id: 'dash-reviews', label: 'My Reviews', icon: 'StarIcon', href: '/user-dashboard', badge: '8' },
  { id: 'dash-activity', label: 'Activity', icon: 'BoltIcon', href: '/user-dashboard', badge: null },
  { id: 'dash-contributor', label: 'Submissions', icon: 'PlusCircleIcon', href: '/user-dashboard', badge: '2' },
  { id: 'dash-settings', label: 'Settings', icon: 'Cog6ToothIcon', href: '/user-dashboard', badge: null },
];

export default function DashboardSidebar() {
  const [active, setActive] = useState('dash-overview');
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside className={`flex-shrink-0 transition-all duration-300 ease-smooth ${collapsed ? 'w-16' : 'w-56'} hidden lg:block`}>
      <div className="sticky top-24">
        {/* User profile mini */}
        {!collapsed && (
          <div className="p-4 rounded-2xl bg-card border border-border mb-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary to-red-800 flex items-center justify-center text-sm font-800 text-white flex-shrink-0">
                MK
              </div>
              <div className="min-w-0">
                <p className="text-sm font-700 text-foreground truncate">Marcus Kim</p>
                <p className="text-xs text-muted-foreground truncate">marcus@cineworld.cloud</p>
                <span className="inline-block mt-1 px-2 py-0.5 text-xs rounded-full bg-purple-500/15 text-purple-400 border border-purple-500/25 font-500">Contributor</span>
              </div>
            </div>
          </div>
        )}

        {/* Nav */}
        <nav className="space-y-1">
          {sidebarLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => setActive(link.id)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-500 transition-all duration-150 ${
                active === link.id
                  ? 'sidebar-active' :'text-muted-foreground hover:text-foreground hover:bg-muted/40'
              }`}
            >
              <Icon name={link.icon as Parameters<typeof Icon>[0]['name']} size={16} className="flex-shrink-0" />
              {!collapsed && (
                <>
                  <span className="flex-1 text-left">{link.label}</span>
                  {link.badge && (
                    <span className="text-xs font-700 bg-primary/15 text-primary px-1.5 py-0.5 rounded-full">{link.badge}</span>
                  )}
                </>
              )}
            </button>
          ))}
        </nav>

        {/* Collapse toggle */}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="mt-4 w-full flex items-center justify-center gap-2 px-3 py-2 rounded-xl text-xs text-muted-foreground hover:text-foreground hover:bg-muted/40 transition-colors"
        >
          <Icon name={collapsed ? 'ChevronRightIcon' : 'ChevronLeftIcon'} size={14} />
          {!collapsed && 'Collapse'}
        </button>
      </div>
    </aside>
  );
}